import {
    type GetAllCompanyUpdateRequestHistoriesResponseType,
    type GetAllCompanyUpdateRequestHistoriesRequestType
} from "./type";
import {
    request
} from "../request";

const getAllCompanyUpdateRequestHistories = async (
    params: GetAllCompanyUpdateRequestHistoriesRequestType
): Promise<GetAllCompanyUpdateRequestHistoriesResponseType> => {
    const searchParams = new URLSearchParams();

    if(params.search) {
        searchParams.append("search", params.search);
    }

    if(params.requestType) {
        searchParams.append("requestType", params.requestType);
    }

    if(params.reason) {
        searchParams.append("reason", params.reason);
    }

    if(params.page !== undefined) {
        searchParams.append("page", String(params.page));
    }

    const queryStr = searchParams.toString();
    const endpoint = queryStr ? `/request/getAllCompanyUpdateRequestHistories?${queryStr}` : "/request/getAllCompanyUpdateRequestHistories";

    return await request<GetAllCompanyUpdateRequestHistoriesResponseType>(endpoint, {
        method: "GET"
    });
};
export default getAllCompanyUpdateRequestHistories;
